export default __webpack_public_path__ + "static/waifuMintIcon-ab24dde6d7e29625feb5771542458233.svg";